/***********************************************************************************
 * Axios plugin
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Cookie from 'js-cookie';

Vue.use(VueAxios, axios);

Vue.axios.interceptors.request.use(
    (config): any => {
        config.headers = {
            ...config.headers,
            ...{
                'X-CSRF-TOKEN': Cookie.get('CSRF-TOKEN') || null
            }
        };

        config.withCredentials = true;

        return config;
    },
    (error): Promise<never> => Promise.reject(error)
);
